export const JSON_POST_HEADERS = {
  'Content-Type': 'application/json',
} as const;
